'use client';

import { useEffect } from 'react';

import type { IDatadogRumConfig } from '@/lib/datadogRumConfig';

let initialized = false;

/**
 * Initializes Datadog RUM once per page load. Same-origin requests (the site's
 * own /api routes, RSC and server action calls) get trace headers injected so
 * each browser request links to its backend APM trace.
 *
 * The SDK is imported dynamically inside an effect so it is never evaluated
 * during SSR / static generation, where each server bundle would load its own
 * copy and the SDK warns "SDK is loaded more than once".
 */
export const DatadogRum = ({ config }: { config: IDatadogRumConfig }) => {
  useEffect(() => {
    if (initialized) return;
    initialized = true;

    import('@datadog/browser-rum').then(({ datadogRum }) => {
      datadogRum.init({
        ...config,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [(url: string) => url.startsWith(globalThis.location.origin)],
      });
    });
  }, [config]);

  return null;
};
